import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import {
    SystemEntity,
    Tag,
    TagCategoryDetails,
} from '@wdx/clmi/clmi-swagger-gen';
import { SimpleTag, TagEntity } from '@wdx/clmi/clmi-swagger-gen';
import { BaseApiService } from '../base-api.service';

@Injectable()
export class TagApiService extends BaseApiService {
    getForRecord(entity: TagEntity, recordId: string): Observable<Tag[]> {
        return this.get<Tag[]>(`tag/${entity}/${recordId}`);
    }

    getCategoriesForSystemEntity(
        systemEntity: SystemEntity,
    ): Observable<TagCategoryDetails[]> {
        return this.get<TagCategoryDetails[]>(
            `tag/category?entityType=${systemEntity}`,
        );
    }

    getForCategory(category: TagCategoryDetails): Observable<SimpleTag[]> {
        return this.get<SimpleTag[]>(`tag/category/${category.type}`);
    }

    createForRecord(
        entity: string,
        entityId: string,
        category: string,
        tagNames: string[],
    ): Observable<Tag[]> {
        return forkJoin(
            tagNames.map((tagName) =>
                this.post<Tag, unknown>(
                    `tag/${entity}/${entityId}/category/${category}?tag=${tagName}`,
                    {},
                ),
            ),
        );
    }

    deleteForRecord(
        entity: string,
        entityId: string,
        category: string,
        tagNames: string[],
    ): Observable<any> {
        return forkJoin(
            tagNames.map((tagName) =>
                this.delete(
                    `tag/${entity}/${entityId}/category/${category}?tag=${tagName}`,
                ),
            ),
        );
    }

    deleteTag(tagName: string): Observable<any> {
        return this.delete(`tag/${tagName}`);
    }

    getForCategoryAndRecord(
        categoryId: string,
        entity: SystemEntity,
        entityId: string,
    ): Observable<SimpleTag[]> {
        return this.get<SimpleTag[]>(
            `tag/${entity}/${entityId}/category/${categoryId}`,
        );
    }

    getAllTags(): Observable<TagCategoryDetails[]> {
        return this.get<TagCategoryDetails[]>(`tag/category`);
    }

    disableTag(tagId: string, isDisabled: boolean): Observable<Tag> {
        return this.patch<Tag, unknown>(
            `tag/${tagId}/disabled/${isDisabled}`,
            {},
        );
    }
}
